import { memo } from 'react';

import { usePlayerStore } from '@air/component-player';

import { useAnnotationV2Store } from '~/components/AnnotationsV2/providers/AnnotationV2Provider';
import { getCommentRangePercentStyle } from '~/components/v2/components/asset-modal/visualizer/video/getCommentRangePercentStyle';

export const VideoCommentRangeBarHighlight = memo(() => {
  const duration = usePlayerStore((state) => state.duration);
  const commentRange = useAnnotationV2Store((state) => state.commentRange);

  if (!commentRange || duration <= 0) {
    return null;
  }

  return (
    <div
      className="pointer-events-none absolute bottom-0 h-1 rounded-4 ads:bg-ads-gray-12 bg-gray-12"
      data-testid="VIDEO_COMMENT_RANGE_BAR_HIGHLIGHT"
      style={getCommentRangePercentStyle(commentRange, duration)}
    />
  );
});

VideoCommentRangeBarHighlight.displayName = 'VideoCommentRangeBarHighlight';
